<template>
  <div>
    <image-banner v-if="banner && banner.banner_image" :banner="banner" hero />
    <v-container v-if="page">
      <div class="my-5">
        <div class="d-flex">
          <div v-if="headings" id="table-of-contents" class="table-of-contents mx-8">
            <h1>Table of Contents</h1>
            <div v-for="heading of headings" :key="heading" class="mt-5 font-large font-weight-bold">
              <a :href="'#' + heading">{{ heading }}</a>
            </div>
          </div>
          <div class="fx-1 px-2 px-sm-4 px-md-8" :class="{ 'border-left': headings }">
            <div v-if="page.include_page_title" class="bpg-page-heading mb-2">
              <h1>{{ page.title }}</h1>
            </div>
            <h2 v-if="page.subtitle" class="text-center mb-8">
              {{ page.subtitle }}
            </h2>

            <div v-if="headings" class="d-flex d-md-none justify-space-around">
              <base-select label="Table of Contents" :items="headings" @input="scrollTo($event)" />
            </div>

            <slices-block :slices="slices" />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import prismicApi from '@/helpers/prismic-api'
import ImageBanner from '@/components/slices/image-banner'
import SlicesBlock from '@/components/slices/slices-block'

export default {
  name: 'PageTemplate',
  components: {
    ImageBanner,
    SlicesBlock
  },
  data () {
    return {
      page: null,
      slices: null,
      banner: null
    }
  },
  head () {
    return (this.page)
      ? {
        title: this.page.meta_title,
        description: this.page.meta_description
      }
      : {
        title: 'Page'
      }
  },
  async asyncData ({ params, error }) {
    try {
      if (params.slug) {
        const result = await prismicApi.getByUID('page', params.slug)
        if (result) {
          let headings = null
          if (result.document && result.document.include_table_of_contents && result.document.body && result.document.body.length) {
            const items = [].concat(...result.document.body.map(x => x.items))
            const textItems = [].concat(...items.map(x => x.text_content))
            headings = textItems.filter(x => x && x.type === 'heading1').map(x => x.text)
          }
          const { body: slices, ...banner } = result.document
          return {
            page: result.document,
            slices,
            banner,
            headings
          }
        }
      }
    } catch (e) {
      return error(e)
    }

    error({
      statusCode: 404,
      message: `
        Sorry, the page you were looking for could not be found! It might have been removed,
        had it's name changed, or is temporarily unavailable.
      `
    })
  },
  methods: {
    scrollTo (heading) {
      this.$router.push('#' + heading)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import 'scss/variables';

  .sticky {
    position: fixed;
    top: 100px;
  }

  .table-of-contents {
    display: none;
    width: 260px;

    h1 {
      font-weight: $font-weight-thin;
      font-size: 3em;
      border-bottom: 1px solid $grey;
      padding-bottom: 8px;
    }

    a {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media screen and (min-width: $breakpoint-sm) {
    .table-of-contents {
      display: block;
    }

    .border-left {
      border-left: 1px solid $grey;
    }
    .sticky + .border-left {
      margin-left: 324px;
    }
  }
</style>
